export default __webpack_public_path__ + "static/media/box.17e39c05.png";